import { PhotoEditorAnnotationCanvasRenderer } from './photo-editor.decorator';
import { CanvasRenderingCtx, drawTick, RulerAnnotation, vectorOf } from '@damofire/uix-commons';

export class RulerPenRenderer implements PhotoEditorAnnotationCanvasRenderer<RulerAnnotation> {
  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    public annotation: RulerAnnotation,
  ) {}

  draw(renderingCtx: CanvasRenderingCtx): void {
    this.ctx.save();

    this.ctx.lineWidth = 2;
    this.ctx.strokeStyle = this.annotation.color;

    this.ctx.beginPath();
    this.ctx.moveTo(this.annotation.origin.x, this.annotation.origin.y);
    this.ctx.lineTo(this.annotation.end.x, this.annotation.end.y);
    this.ctx.stroke();
    this.ctx.closePath();

    const direction = vectorOf(this.annotation.origin, this.annotation.end);

    // Draw origin tick
    drawTick(this.ctx, this.annotation.origin, direction);

    // Draw end tick
    drawTick(this.ctx, this.annotation.end, direction);

    this.ctx.restore();
  }
}
